export const API_URL = 'https://api.videahealth.io/v1';
export const CONNECTOR_API_URL = 'https://connector.videahealth.io';
export const PARSE_APPLICATION_ID =
  'DwjY3wpxaUUR2Ehd4acfuRATcHuei7sPr4aHhUUjGB';
export const NETWORK_REQUEST_TIMEOUT_IN_MILLIS = 60000;
export const VIDEA_BEACON_URL = 'ws://localhost:8090/Watcher';
export const OPS_DASHBOARD_SHOW_WATCHLIST = false;
